export async function executeJob(token, revenueTargetingModelID, type) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/execute-job/`,
        {
          method: "POST",
          headers: new Headers({
            Authorization: token,
            Accept: "application/json",
          }),
          body: JSON.stringify({
            rtm_id: revenueTargetingModelID,
            job_type: type
          }),

        }
      );
      return response;
    } catch (error) {
      return {};
    }
  }